import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, useDisclosure ,useToast} from '@chakra-ui/react'
import { useEffect, useRef, useState } from 'react'
import { getEmail } from '../../classes/Email'
import { AL_EDIT, defaultSelectData, useSelectedItemAlertContext } from '../../context/selectedItemAlertContext'
import { useUserContext } from '../../context/userContext'
import EmailForm from './EmailForm'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'


const ModalEmailEdit = ({ data }) => {
    const { onClose, isOpen, onOpen } = useDisclosure()
    const { setItemData } = useSelectedItemAlertContext()
    const { userData } = useUserContext()
    const [emailData, setEmailData] = useState(null)
    const toast = useToast()

    const openModal = useRef()
    openModal.current = () => {
        if (data?.type === AL_EDIT) onOpen()
    }

    const loadData = useRef()
    loadData.current = async () => {
        await getEmail(data?.id, userData.token)
            .then(res => {
                setEmailData(res)
                openModal.current()
            })
            .catch(error => {
                // console.log(error)
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    useEffect(() => {
        loadData.current()
    }, [data])

    const onCloseHandle = () => {
        setItemData(defaultSelectData)
        onClose()
    }

    return (
        <Modal isOpen={isOpen} onClose={onCloseHandle} size="4xl" motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>แก้ไขข้อมูลรูปแบบอีเมล</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {emailData && <EmailForm defaultData={emailData} close={onCloseHandle} mode={AL_EDIT} />}
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default ModalEmailEdit
